// extracted by mini-css-extract-plugin
export default {"settingsAccordion":"AdvancedSettings_settingsAccordion__C4Ruu","settingsBoxForm":"AdvancedSettings_settingsBoxForm__vno-9"};